import React from "react";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleRight } from "@fortawesome/free-solid-svg-icons";


const Accordian = ({ title, content, index, length }) => {

    const [isActive, setIsActive] = useState(false);
    

return (
    <>
        <div key={index} className={`${isActive === false ? "flex flex-col justify-center" : "flex flex-col justify-center"} bg-[#2D4F71] ${index === 0 ? 'md:rounded-tl-xl rounded-t-xl md:rounded-tr-none' : index === 1 ? 'md:rounded-tr-xl' : index === 6 ? 'rounded-bl-xl rounded-br-xl md:rounded-br-none' : index === length -1 ? 'rounded-br-xl rounded-b-xl md:rounded-bl-none' : index === length - 2 ? 'rounded-br-xl' : ''} py-2 px-3 ${index === length - 1 ? 'hidden md:block' : null}`}>
            <div className="flex flex-row justify-between items-center w-full" onClick={(event) => {setIsActive(!isActive)}}>
                <div className="text-sm font-medium leading-5 tracking-wide text-left cursor-pointer py-2" dangerouslySetInnerHTML={{ __html: title}}/>
                {title?.length > 0 && <FontAwesomeIcon icon={isActive ? faAngleDown :faAngleRight} className="tracking-widest text-2xl text-[#7FC241] px-2" />}
            </div>
            {isActive && <div className="mt-2 text-sm text-left pb-2" dangerouslySetInnerHTML={{ __html: content }}/>}
        </div>
    </>
    
);
};

export default Accordian;
